// extracted by mini-css-extract-plugin
export default {"container":"ExplainContent_container__y7aeO","explain":"ExplainContent_explain__zFDe3","explainRating":"ExplainContent_explainRating__L3X-E"};